import { api } from "@/client/api";
import { useAuth } from "@clerk/nextjs";

export const useUserCards = () => {
  const auth = useAuth();
  return api.cards.findAll.useQuery(undefined, {
    enabled: auth.isSignedIn ?? false,
  });
};
